import assessmentApplicationSurvey from "./assessmentApplicationSurvey";

const questionnaireService = [{
    matcher: /questionnaire\/(.*)/,
    reply: config => {
        const id = /questionnaire\/(.*)/.exec(config.url)[1];
        return [200, assessmentApplicationSurvey];
    }
}]

export default questionnaireService;